import { IApplicationState, TBoardId } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserFirstTemplateBoardId = (
    state: IApplicationState
): TBoardId => {
    const user = getAuthUser(state);
    if (!user.meta) return null;

    return user.meta.firstTemplateBoardId;
};
